import SurfaceStill from "./SurfaceStill";

export default function Surface4({ direction = "forward", onBegin }) {
  return (
    <SurfaceStill
      className="tgc-v2-surface--preparation"
      direction={direction}
      headline="Thank you."
      body="Now we'll build the conversation. About five minutes -- answer like you're telling a good friend about them. Their answers shape what they hear, what the AI knows, and the keepsake they leave with."
      primaryLabel="Begin"
      onPrimary={onBegin}
    />
  );
}
